<template>
  <div id="FileManagement">
    <dashboardMenu @updateCategories="[]" />

    <alertConfirmAction
      v-if="toggleAlertConfirmAction"
      :confirmText="'Excluir'"
      @confirmAction="removeFile"
      @cancelAction="toggleAlertConfirmAction = false; itemToRemove = null;"
    >
      <h5 slot="title">Excluir arquivo?</h5>
      <p slot="text">Deseja realmente remover este arquivo?</p>
    </alertConfirmAction>

    <div class="container">
      <div class="row mb-4 align-items-center">
        <div class="col">
          <h3>Arquivos disponíveis</h3>
        </div>
        <div class="col-12 col-md-auto">
          <span class="pointer btn btn-primario py-2" @click="newFileHandler">
            <i class="fal fa-plus"></i> Novo
          </span>
        </div>
      </div>
      
      <div v-if="loadingFiles" class="text-center">
        <i class="fal fa-spinner fa-spin fa-2x"></i>
      </div>

      <div v-else-if="files.length == 0">
          <p>Você ainda não possui arquivos enviados. Clique no botão "Novo" para disponiblizar um novo arquivo.</p>
      </div>

      <div v-else class="row">
        <div class="col-12 col-md-6 mb-3" v-for="(item, index) in files" :key="index">
           <div class="card advertise-card">
            <div class="card-body py-3 d-flex">
              <div class="file-thumbnail">
                <template>
                  <i class="far fa-file-alt fa-3x"></i>
                </template>
              </div>
              <div class="file-data">
                <h5>{{item.name}}</h5>
                <p>
                  <strong>Url:</strong>
                  <a
                    :href="'https://' + item.domain + item.route_path"
                    target="_blank"
                    rel="noopener noreferrer"
                  >{{item.domain + item.route_path}}</a>
                </p>
                <div class="m-0 text-right">
                  <!--<span
                    @click="toggleAdvertise(item)"
                    v-if="item.status == 1"
                    class="pointer toggle-on"
                  >
                    <i class="fal fa-toggle-on fa-2x text-success"></i>
                  </span>
                  <span @click="toggleAdvertise(item)" v-else class="pointer toggle-off">
                    <i class="fal fa-toggle-off fa-2x opacity-50"></i>
                  </span>-->
                  <span class="remove-button pointer mx-2" @click="copyLink(item.path)"><i class="far fa-copy"></i></span>
                  <span @click="handleRemoveFile(item.id)" class="pointer remove-button">
                    <i class="fal fa-trash-alt"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--<div class="row">
        <div class="col-12 py-5">
          <p>Utilize este recurso para disponibilizar arquivos para serem acessados ou baixados pelos seus visitantes, como PDFs, planilhas e etc.</p>
        </div>
      </div>-->


      <!-- Modal para adição de arquivo -->
      <b-modal
        ref="newFileModal"
        id="newFileModal"
        centered
        hide-footer
        title="Adicionar arquivo"
        @hidden="clearModal"
      >
        <b-container>
          <input
            type="file"
            ref="file"
            @change="uploadNewFile"
            hidden
          />
          <form action @submit.prevent="addFile">
            <div class="row justify-content-between">

                <div class="col-12 form-group">
                    <label for="newAdivertiseTitle">Nome do arquivo</label>
                    <input
                    type="text"
                    id="newFileName"
                    class="form-control"
                    v-model="newFile.name"
                    required
                    />
                </div>
  
                <div class="col-12 col-md-8 form-group">
                    <label for="newAdivertiseTitle">Caminho</label>
                    <input
                    type="text"
                    id="newFilePath"
                    class="form-control"
                    v-model="newFile.path"
                    required
                    />
                    <p><small>Exemplo: <br>{{ domain + '/downloads/' + newFile.path }}</small></p>
                </div>

                <div class="col-12 col-md-4 add-image-container mb-3">

                    <span v-if="uploading" class="add-image-span pointer text-center">
                          <i class="fal fa-spinner fa-spin fa-2x"></i>
                    </span>

                    <span v-else-if="!newFile.file" @click="addFile_" class="add-image-span pointer text-center">
                      <i class="far fa-file-alt s fa-2x"></i>
                      <br />Enviar
                    </span>

                    <span v-else class="add-image-span pointer text-center">
                      <i class="far fa-check s fa-2x"></i>
                      <br />Enviado
                    </span>
                    
                </div>

                <div v-if="message" class="col-12 text-center mb-3">
                  <small class="error-message">{{ message }}</small>
                </div>
                
                <div class="col-auto align-self-center mt-3">
                    <span class="pointer py-2" @click="$bvModal.hide('newFileModal')">Cancelar</span>
                </div>
                <div class="col-auto mt-3">
                    <button class="btn btn-primario py-2" :disabled="saving || uploading ? true : false">Salvar</button>
                </div>
            </div>
          </form>
        </b-container>
      </b-modal>

    </div>
  </div>
</template>

<script>
import axios from "axios";
import apiMixins from "@/mixins/apiMixins";
import dashboardMenu from "@/components/DashboardMenu";
import alertConfirmAction from "@/components/organisms/AlertConfirmAction";

export default {
    name: "FileManagement",
    data() {
        return {
            loadingFiles: true,
            files: [],
            toggleAlertConfirmAction: false,
            saving: false,
            uploading: false,
            message: '',
            itemToRemove: null,
            domain: '',
            newFile: {
                id: null,
                file: null,
                name: '',
                path: ''
            }
        };
    },
    mixins: [apiMixins],
    components: {
        dashboardMenu,
        alertConfirmAction
    },
    filters: {
        urlComplete(value) {
        return `${process.env.CDN_URL}${value}`;
        }
    },
    watch: {
        "newFile.name"() {
          this.newFile.path = this.slug(this.newFile.name);
        }
    },
    methods: {
        clearModal() {
            this.newFile = {
                file: null,
                name: '',
                path: ''
            };
            this.saving = false;
        },
        newFileHandler() {
          this.newFile = {
            id: null,
            file: null,
            name: '',
            path: ''
          };

          this.message = '';

          this.$refs.newFileModal.show();
        },
        addFile_() {
          this.$refs.file.click();
        },
        getSiteFiles() {
            const siteId = this.$session.get("siteId");
            const token = this.$session.get("jwt");
            
            this.loadingFiles = true;
            this.files = [];
            
            axios({
                method: "get",
                url: `${process.env.ROOT_API}api/site/${siteId}/file`,
                headers: {
                Authorization: "Bearer " + token
                // 'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(response => {
                if (response.data.status == "1") {
                  this.files = response.data.data;
                }
            })
            .finally(() => {
                this.loadingFiles = false;
            });


        },
        uploadNewFile() {
          this.submitFile(this.$refs.file.files[0]);
        },
        checkFile(file){
          // Verifica se o arquivo é de uma extensão inválida
          const forbid = ['exe', 'sql', 'bat', 'bash', 'bin'];
          let error = false;
          let str = this.$refs.file.files[0].name.toLowerCase().split(".");
          let ext = str[str.length - 1];
          
          if(forbid.includes(ext)){
            error = 'Arquivo do tipo .' + ext + ' não suportado.';
          }
          else if(file.size > 30*1000*1000){
            error = 'Não é possível enviar um arquivo maior do que 30MB.'
          }

          return error;
        },
        submitFile(file) {
          let error = this.checkFile(file);
          const siteId = this.$session.get("siteId");
          const token = this.$session.get("jwt");
          
          this.message = '';
          this.uploading = true;

          if(error){
            this.message = error;
            this.$refs.file.value = ''; //Limpa o input
            this.uploading = false;
          }
          else{
            let formData = new FormData();
            formData.append("upload", file);
  
            axios({
              method: "post",
              url: `${process.env.ROOT_API}api/site/${siteId}/file/create`,
              data: formData,
              headers: {
                Authorization: "Bearer " + token
                // 'Content-Type': 'application/x-www-form-urlencoded'
              }
            })
            .then(response => {
              if(response.data.status == '1'){
                //Se o usuário não tive definido nome, aplica o nome do arquivo original
                if(!this.newFile.name){
                  this.newFile.name = this.$refs.file.files[0].name;
                  this.newFile.path = this.$refs.file.files[0].name;                
                }
                //Senão, aplica a extensão do arquivo enviado no nome do arquivo definido
                else{
                  let str = this.$refs.file.files[0].name.toLowerCase().split(".");
                  let ext = str[str.length - 1];
                  this.newFile.path = this.slug(this.newFile.path + '.' + ext);
                }
                this.newFile.file = response.data.data;
              }
            })
            .catch( () => {
              this.message = "Falha ao enviar o arquivo, tente novamente";
            })
            .finally( () => {
              this.uploading = false;
            });
            
          }
          
        },
        slug(str){
          str = str.replace(/^\s+|\s+$/g, ''); // trim
          str = str.toLowerCase();
        
          // remove accents, swap ñ for n, etc
          var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
          var to   = "aaaaeeeeiiiioooouuuunc------";

          for (var i=0, l=from.length ; i<l ; i++) {
              str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
          }

          str = str.replace(/\(/g, '');
          str = str.replace(/\)/g, '');

          str = str.replace(/[^a-z0-9 -|.]/g, '') // remove invalid chars
              .replace(/\s+/g, '-') // collapse whitespace and replace by -
              .replace(/-+/g, '-'); // collapse dashes

          return str;
        },
        async addFile() {
          const siteId = this.$session.get("siteId");
          const url = `/site/${this.$session.get("siteId")}/file/create`;
          const token = this.$session.get("jwt");
          this.newFile.path = this.slug(this.newFile.path);
          this.errorImage = false;
          this.message = '';

          if(!this.newFile.file){
            this.message = 'Sem arquivo';
          }
          else{
            this.saving = true;

            axios({
              method: "post",
              url: `${process.env.ROOT_API}api/site/${siteId}/file/create`,
              data: this.newFile,
              headers: {
                Authorization: "Bearer " + token
                // 'Content-Type': 'application/x-www-form-urlencoded'
              }
            })
            .then(response => {
              if(response.data.status == '0'){
                this.message = response.data.message;
              }
              else{
                this.getSiteFiles();
                this.$refs.newFileModal.hide();
              }
            })
            .catch( () => {
              this.message = "Falha ao enviar o arquivo, tente novamente";
            })
            .finally( () =>{
              this.saving = false;
            });
            
          }


        },
        copyLink(path){
          const fullUrl = process.env.CONTAINER_URL + path;
          navigator.clipboard.writeText(fullUrl);
        },
        handleRemoveFile(id) {
          this.itemToRemove = id;
          this.toggleAlertConfirmAction = true;
        },
        async removeFile() {
          const url = `/site/${this.$session.get(
            "siteId"
          )}/file/${this.itemToRemove}/delete`;
          
          const statusRequest = await this.requestApiData(url, "delete");
          
          if (statusRequest.status != "1") {
            this.message = "Erro ao remover o arquivo";
          }
          
          this.toggleAlertConfirmAction = false;
          this.itemToRemove = null;
          this.getSiteFiles();
        },
    },
    created() {
        this.$store.dispatch("VERIFY_TOKEN");
        this.$store.dispatch("VERIFY_SITE");
        this.getSiteFiles();
        this.domain = this.$session.get("domain");
    }
};
</script>

<style scoped>
.add-image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
}
.add-image-container img {
  object-fit: cover;
}
.add-image-span {
  background-color: #f2f2f2;
  color: #858585;
  padding: 14px 39px;
  font-weight: 700;
}
.file-thumbnail {
  display: flex;
  width: 33%;
  min-height: 90px;
  padding: 0 10px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #858585;
}
.file-data {
  font-size: 0.8rem;
  display: flex;
  flex-direction: column;
  width: 65%;
  min-height: 90px;
}
.remove-button {
  font-size: 1rem;
  color: #858585;
  transition: all 300ms;
}
.remove-button:hover {
  color: var(--error-color);
}
.toggle-off {
  color: #858585;
  transition: all 300ms;
}
</style>


// WEBPACK FOOTER //
// src/components/templates/FileManagement.vue